import GroupNote from "../Entity/GroupNote";
import CrudApi from "@serie3/common/api/crudApi";
import MediaplannerGroupEndpoints from "../endpoints";
import listHandler from "@serie3/common/Domain/listHandler";

const createGroupNoteForm = (notes, setNotes, groupId, setShowModal) => {
  const onSubmit = async (values, { resetForm }) => {
    if (values.id > 0) {
      const response = await CrudApi.edit(
        MediaplannerGroupEndpoints.endpoints.notes.edit + values.id,
        JSON.stringify({ title: values.title, content: values.content })
      );
      if (response.ok) {
        listHandler.replaceItemInList(response.data, notes, setNotes);
        setShowModal(false);
        resetForm();
      }
    } else {
      const response = await CrudApi.createNew(
        MediaplannerGroupEndpoints.endpoints.notes.new + groupId,
        { title: values.title, content: values.content }
      );
      if (response.ok) {
        listHandler.newToList(response, notes, setNotes, null, true);
        setShowModal(false);
        resetForm();
      }
    }
  };

  return {
    initialValues: { ...GroupNote },
    onSubmit,
  };
};

const setEditData = (note) => ({
  id: note.id,
  title: note.title ?? "",
  content: note.content ?? "",
});

export default { createGroupNoteForm, setEditData };
